class SettingsService {
  constructor($http, $rootScope) {
    "ngInject";
    this.name = 'SettingsService';
    this.$http = $http;
    this.baseUrl = $rootScope.apiHost +'/api/admin/';

    this.autoBalanceLeave = true;

    this.autoBalanceLeaveChargeCode = {
      id: 31,
      name: 'FRINGE-PTO',
      description: "Paid Time Off",
      rate: 0,
      effectiveDate: null,
      expirationDate: null,
      leaveType: true
    };

    this.roundingInterval = 0.05;
    this.dcaaEnabled = true;

    this.workingHoursPerDay = 8;
    this.excludeWeekends = true;
    this.excludeHolidays = true;
    this.holidays = {
      '01/01': "New Year's Day",
      '01/15': "MLK Day",
      '02/19': "Presidents Day",
      '05/28': "Memorial Day",
      '07/04': "Independence Day",
      '09/03': "Labor Day",
      '10/08': "Columbus Day",
      '11/10': "Veteran's Day",
      '11/23': "Thanksgiving Day",
      '12/25': "Christmas Day"
    }

  }

  getNameForChargeCodes() {
    return 'tasks';
  }

  getCompany() {
    return this.$http.get(this.baseUrl+'companies/mycompany', {withCredentials: true});
  }

  updateCompany(company) {
    let config = {
      withCredentials: true
    };
    config.headers = {
      'Content-Type': 'application/json',
    };


    let comp = {};
    angular.copy(company, comp);

    return this.$http.put(this.baseUrl+"companies/mycompany", comp, config);
  }

  getRoundingInterval() {
    return this.roundingInterval;
  }

  isDcaaEnabled() {
    return this.dcaaEnabled;
  }

  getWorkingHoursPerDay() {
    return this.workingHoursPerDay;
  }

  isExcludeWeekends(){
    return this.excludeWeekends;
  }

  isExcludeHolidays(){
    return this.excludeHolidays;
  }

  getHolidays(){
    return this.holidays;
  }


}

export default SettingsService;



// WEBPACK FOOTER //
// ./client/common/services/settings/settings.service.js